export default __webpack_public_path__ + "static/media/living7.089ef922.jpg";